"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../");

require("./FinderTabs.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FinderTabs extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      index: 0,
      tabs: [],
      tabpanels: []
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (prevProps.tabIndex !== this.props.tabIndex) {
        this.getTabs();
      }

      if (prevProps.tabId !== this.props.tabId) {
        this.getTabs();
      }

      if (prevProps.children !== this.props.children) {
        this.getTabs();
      }
    });

    _defineProperty(this, "getTabpanel", (child, index) => {
      const _child$props = child.props,
            id = _child$props.id,
            url = _child$props.url,
            title = _child$props.title,
            children = _child$props.children;
      const tabpanelId = id || "admin-tabs-" + index;
      const tabId = tabpanelId + "-tab";
      return {
        index: index,
        id: tabpanelId,
        labelledby: tabId,
        children: children
      };
    });

    _defineProperty(this, "getTab", (child, index) => {
      const _child$props2 = child.props,
            id = _child$props2.id,
            url = _child$props2.url,
            title = _child$props2.title,
            children = _child$props2.children;
      const tabpanelId = id || "admin-tabs-" + index;
      const tabId = tabpanelId + "-tab";
      return {
        index: index,
        url: url,
        id: tabId,
        controls: tabpanelId,
        title: title
      };
    });

    _defineProperty(this, "getTabs", () => {
      const _this$props = this.props,
            tabIndex = _this$props.tabIndex,
            tabId = _this$props.tabId;

      if (!this.props.children) {
        return false;
      }

      const tabs = _react.default.Children.toArray(this.props.children).map(this.getTab);

      const tabpanels = _react.default.Children.toArray(this.props.children).map(this.getTabpanel);

      let tabsById = {};
      tabpanels.map(tab => {
        tabsById[tab.id] = tab;
      });

      if (!tabsById) {
        return false;
      } // set index by tabId or tabIndex


      const index = tabId && tabsById && tabsById[tabId] && tabsById[tabId].index || tabIndex;
      this.setState({
        index: index,
        tabs: tabs,
        tabpanels: tabpanels
      });
    });

    _defineProperty(this, "renderTabpanel", (tabpanel, index) => {
      const id = tabpanel.id,
            labelledby = tabpanel.labelledby,
            children = tabpanel.children;
      const selected = this.state.index === index;
      return _react.default.createElement("div", {
        className: "admin-finder__tabpanel",
        role: "tabpanel",
        id: id,
        "aria-selected": selected,
        "aria-labelledby": labelledby,
        key: id
      }, children);
    });

    _defineProperty(this, "renderTab", (tab, index) => {
      const id = tab.id,
            controls = tab.controls,
            url = tab.url,
            title = tab.title;
      const selected = this.state.index === index;
      return _react.default.createElement(_.ButtonTertiary, {
        key: id,
        title: title,
        url: url,
        id: id,
        controls: controls,
        role: "tab",
        selected: selected,
        onClick: event => this.onSelect(tab, event)
      });
    });

    _defineProperty(this, "onSelect", (tab, event) => {
      const id = tab.id,
            index = tab.index;
      this.setState({
        index: index,
        id: id
      });

      if (this.props.onSelect) {
        this.props.onSelect(tab, event);
      }
    });
  }

  componentDidMount() {
    this.getTabs();
  }

  render() {
    const _this$state = this.state,
          tabs = _this$state.tabs,
          tabpanels = _this$state.tabpanels;
    return _react.default.createElement("div", {
      className: "admin-finder__tabs",
      role: "dialog"
    }, _react.default.createElement("nav", {
      className: "nav-tabs"
    }, tabs.map(this.renderTab)), tabpanels.map(this.renderTabpanel));
  }

}

_defineProperty(FinderTabs, "defaultProps", {
  tabIndex: 0,
  tabId: undefined
});

var _default = FinderTabs;
exports.default = _default;
module.exports = exports.default;